(function () {
  'use strict';

  var script = document.currentScript;
  var fallbackSrc = script && script.getAttribute('data-fallback-src');
  var selector = [
    'img.jdgm-carousel-item__product-image',
    'img.jdgm-rev__pic-img',
    '.jdgm-carousel-item__product-image img',
    '.jdgm-rev__pic-img img'
  ].join(',');

  if (!fallbackSrc) return;

  function isReviewImage(image) {
    return image && image.nodeType === 1 && image.matches(selector);
  }

  function isFailed(image) {
    var source = image.currentSrc || image.getAttribute('src') ||
      image.getAttribute('data-src') || image.getAttribute('data-src-retina');
    return source && image.complete && image.naturalWidth === 0;
  }

  function finishFallback(image) {
    var reviewContainer = image.closest('.jdgm-rev__pic-link, .jdgm-carousel-item__product-image');
    if (reviewContainer) {
      reviewContainer.classList.remove('jdgm--loading');
      reviewContainer.classList.add('ss-review-fallback-ready');
    }
    image.style.visibility = 'visible';
  }

  function installFallback(image) {
    if (!isReviewImage(image)) return;
    if (image.dataset.ssReviewFallback === 'true') {
      finishFallback(image);
      return;
    }
    image.dataset.ssReviewFallback = 'true';
    image.classList.add('ss-review-image-fallback');
    image.removeAttribute('srcset');
    image.removeAttribute('sizes');
    image.removeAttribute('data-src');
    image.removeAttribute('data-srcset');
    image.removeAttribute('data-src-retina');
    image.alt = 'Sacred Surreal';
    image.addEventListener('load', function () {
      finishFallback(image);
    }, { once: true });
    image.src = fallbackSrc;
    if (image.complete && image.naturalWidth > 0) finishFallback(image);
    window.setTimeout(function () { finishFallback(image); }, 250);
  }

  function repairExistingFailures() {
    document.querySelectorAll(selector).forEach(function (image) {
      if (image.dataset.ssReviewFallback === 'true') {
        finishFallback(image);
      } else if (isFailed(image)) {
        installFallback(image);
      }
    });
  }

  document.addEventListener('error', function (event) {
    installFallback(event.target);
  }, true);

  function start() {
    repairExistingFailures();
    window.setTimeout(repairExistingFailures, 5000);
    window.setTimeout(repairExistingFailures, 10000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
}());
